import React from 'react';
import FlashSell from '../Home/FlashSell/FlashSell';
import Footer from '../Sheared/Footer/Footer';
import Navbar from '../Sheared/Navbar/Navbar';
import BannerPageNotFound from '../../Images/page-found-with-people-connecting-plug-concept-illustration_114360-1927.jpg'

const PageNotFound = () => {
    return (
        <div>
            <Navbar></Navbar>
            <div className="text-center">
                <img className="img-fluid" src={BannerPageNotFound} alt=""/>
            </div>
            <FlashSell></FlashSell>
            <Footer></Footer>
        </div>
    );
};

export default PageNotFound;